/* ============
 * Getters for the image module
 * ============
 *
 * The getters that are available on the
 * account module.
 */

export default {};
